<div
  class="flex h-full flex-col gap-3 rounded-2xl border p-3 transition-[border-color,opacity] duration-300"
  [class.border-shikenso-pink-base]="selected()"
  [class.border-shikenso-purple-base-12]="!selected()"
  [class.opacity-50]="dimmed()"
>
  <div class="relative">
    @defer (on viewport) {
      <app-finding-image
        class="block"
        [findingId]="data().id"
        [analyticsImage]="data().analyticsImage"
        [canLoad]="canLoadImage()"
        [campaignExportId]="imageCampaignExportId()"
        [aspectRatio]="aspectRatio()"
        [alt]="
          'pages.campaignDetails.ctaAnalytics.details.findingCards.imageAlt' | translate: { number: data().number }
        "
      />
    } @placeholder {
      <!-- Block element: it is the viewport trigger of the @defer above. -->
      <app-finding-image class="block" [findingId]="data().id" [aspectRatio]="aspectRatio()" />
    }

    <!-- 16px circle for 1-2 digits; widens into a pill for 3+ digits. -->
    <span
      class="absolute left-2 top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-shikenso-pink-base text-[10px] font-bold leading-none"
      [class.px-1]="data().number >= 100"
      [class.text-shikenso-base-white]="numberColor()"
      [style.background-color]="numberColor()"
    >
      {{ data().number }}
    </span>

    <div class="absolute right-2 top-2">
      <ng-content select="[findingCardActions]" />
    </div>

    @if (durationLabel(); as duration) {
      <span
        class="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-shikenso-purple-base-60 px-1 py-0.5 text-[10px] leading-4 text-shikenso-base-white"
      >
        <app-icon src="/icons/clock.svg" alt="" color="var(--shikenso-base-white)" [size]="12" />
        {{ duration }}
      </span>
    }
  </div>

  <div class="flex gap-9">
    @if (data().realTime) {
      <div class="flex flex-col gap-1">
        <span class="text-xs text-shikenso-purple-base-60">
          {{ 'pages.campaignDetails.ctaAnalytics.details.findingCards.realTime' | translate }}
        </span>
        <span class="text-sm">{{ data().realTime | date: displayTimeFormat }}</span>
      </div>
    }
    <div class="flex flex-col gap-1">
      <span class="text-xs text-shikenso-purple-base-60">
        {{ 'pages.campaignDetails.ctaAnalytics.details.findingCards.videoTime' | translate }}
      </span>
      <span class="text-sm">{{ data().videoTimeLabel }}</span>
    </div>
  </div>

  <button
    mat-flat-button
    color="secondary"
    type="button"
    class="mat-slim-button mt-auto w-full"
    (click)="openOnPlatform.emit($event)"
  >
    <div class="flex items-center justify-center gap-1">
      <span>{{ 'pages.campaignDetails.ctaAnalytics.details.findingCards.openOnPlatform' | translate }}</span>
      <app-icon src="/icons/arrow-up-right.svg" alt="" [size]="12" />
    </div>
  </button>
</div>
